import React, { FC, HTMLAttributes, useContext } from 'react';
import { ConfigContext } from '../../../providers';
import { cn } from '../../../helpers';

/**
 * PopupContent
 */
export const PopupContent: FC<HTMLAttributes<HTMLElement>> = ({ className, children, ...props }) => {
    const { colors } = useContext(ConfigContext);

    const classNames = cn('h-100 bg-light-grey', {
        [className]: className,
    });

    return (
        <div className={classNames} style={{ backgroundColor: colors.popup.background }} {...props}>
            {children}
        </div>
    );
};
